import { render, staticRenderFns } from "./SectionCatalogue.vue?vue&type=template&id=39d84534&scoped=true"
import script from "./SectionCatalogue.vue?vue&type=script&lang=js"
export * from "./SectionCatalogue.vue?vue&type=script&lang=js"
import style0 from "./SectionCatalogue.vue?vue&type=style&index=0&id=39d84534&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d84534",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d84534')) {
      api.createRecord('39d84534', component.options)
    } else {
      api.reload('39d84534', component.options)
    }
    module.hot.accept("./SectionCatalogue.vue?vue&type=template&id=39d84534&scoped=true", function () {
      api.rerender('39d84534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SectionCatalogue.vue"
export default component.exports